var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNhnsolution6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5939 14.4385C8.83244 14.4385 6.59386 16.677 6.59386 19.4385V56.085H3.66797V62.5425H38.9058V56.085H35.9791V19.4385C35.9791 16.6771 33.7406 14.4385 30.9791 14.4385H11.5939Z",
    fill: "url(#paint0_linear_2137_19264)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3292 14.4385C27.5678 14.4385 25.3292 16.677 25.3292 19.4385V56.085H20.4395V62.5424H48.5246V56.085H43.4506V19.4385C43.4506 16.6771 41.212 14.4385 38.4506 14.4385H30.3292Z",
    fill: "url(#paint1_linear_2137_19264)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5079 24.29C33.7465 24.29 31.5079 26.5286 31.5079 29.29V57.4074H28.582V62.5424H63.8199V57.4074H60.8932V29.29C60.8932 26.5286 58.6546 24.29 55.8932 24.29H36.5079Z",
    fill: "url(#paint2_linear_2137_19264)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.25 24.29C52.4886 24.29 50.25 26.5286 50.25 29.29V57.4074H45.3594V62.5424H73.4445V57.4074H68.3714V29.29C68.3714 26.5286 66.1328 24.29 63.3713 24.29H55.25Z",
    fill: "url(#paint3_linear_2137_19264)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7227 46.0451C35.7227 43.6274 37.6826 41.6675 40.1003 41.6675V41.6675C42.518 41.6675 44.4779 43.6274 44.4779 46.0451V56.1284H35.7227V46.0451Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7227 46.0451C35.7227 43.6274 37.6826 41.6675 40.1003 41.6675V41.6675C42.518 41.6675 44.4779 43.6274 44.4779 46.0451V56.1284H35.7227V46.0451Z",
    fill: "url(#paint4_linear_2137_19264)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8066 46.0451C10.8066 43.6274 12.7666 41.6675 15.1843 41.6675V41.6675C17.602 41.6675 19.5619 43.6274 19.5619 46.0451V56.1284H10.8066V46.0451Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8066 46.0451C10.8066 43.6274 12.7666 41.6675 15.1843 41.6675V41.6675C17.602 41.6675 19.5619 43.6274 19.5619 46.0451V56.1284H10.8066V46.0451Z",
    fill: "url(#paint5_linear_2137_19264)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.0176,
    y: 28.9946,
    width: 3.41,
    height: 3.41406,
    rx: 1.705,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.0176,
    y: 28.9946,
    width: 3.41,
    height: 3.41406,
    rx: 1.705,
    fill: "url(#paint6_linear_2137_19264)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5547,
    y: 28.9946,
    width: 3.41,
    height: 3.41406,
    rx: 1.705,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5547,
    y: 28.9946,
    width: 3.41,
    height: 3.41406,
    rx: 1.705,
    fill: "url(#paint7_linear_2137_19264)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.09766,
    y: 18.9023,
    width: 3.41,
    height: 3.41406,
    rx: 1.705,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.09766,
    y: 18.9023,
    width: 3.41,
    height: 3.41406,
    rx: 1.705,
    fill: "url(#paint8_linear_2137_19264)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6348,
    y: 18.9023,
    width: 3.41,
    height: 3.41406,
    rx: 1.705,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6348,
    y: 18.9023,
    width: 3.41,
    height: 3.41406,
    rx: 1.705,
    fill: "url(#paint9_linear_2137_19264)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_19264",
    x1: 17.7622,
    y1: 30.478,
    x2: -20.6882,
    y2: 84.6353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EA0D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2137_19264",
    x1: 38.422,
    y1: 25.4238,
    x2: 20.5938,
    y2: 87.0269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4367AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2137_19264",
    x1: 42.6762,
    y1: 37.0447,
    x2: 14.9454,
    y2: 86.1627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EA0D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2137_19264",
    x1: 63.3419,
    y1: 33.0256,
    x2: 51.7386,
    y2: 83.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4367AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2137_19264",
    x1: 41.3285,
    y1: 44.9699,
    x2: 36.1321,
    y2: 63.5897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4367AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2137_19264",
    x1: 16.4125,
    y1: 44.9699,
    x2: 11.2161,
    y2: 63.5897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4367AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2137_19264",
    x1: 36.201,
    y1: 29.7743,
    x2: 35.4217,
    y2: 34.3808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4367AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2137_19264",
    x1: 40.7381,
    y1: 29.7743,
    x2: 39.9588,
    y2: 34.3808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4367AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2137_19264",
    x1: 11.281,
    y1: 19.682,
    x2: 10.5018,
    y2: 24.2885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4367AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2137_19264",
    x1: 15.8181,
    y1: 19.682,
    x2: 15.0389,
    y2: 24.2885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4367AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNhnsolution6);
export default __webpack_public_path__ + "static/media/nhnsolution6.45f6c6a09dd17549efd4695299955dd0.svg";
export { ForwardRef as ReactComponent };